/**
 * @author Akshay Kumar Singh
 * @file Alert Modal
 * @flow
 */
import React, { Component } from 'react';
import * as CONSTANT from "../../shared/constants/data";

import Modal from 'react-responsive-modal';
import { withRouter } from "react-router";

class AlertModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      modalMessage: '',
      data: '',
      path: ''
    }
    AlertModal._singletonRef = this;
  }

  /**
   * @description This function called to show alert modal.
   * @param message It has the message to be shown on Alert modal.
   * @param path It has value which decides where to do on pressing OK button of modal.
   * @param data It has data to be passed from calling function.
   * @param obj It has Object ref of calling component.
   */
  static showAlert = (message, path, data) => {
    AlertModal._singletonRef.setState({
      path: path,
      data: data
    });
    AlertModal._singletonRef.openAlertModal(message);
  }

  /**
   * @description This function hides the alert modal.
   */
  static hideAlert = () => {
    AlertModal._singletonRef.setState({
      open: false
    });
  }

  /**
   * @description This function open alert modal
   * @param message It has the alert message to be shown.
   */
  openAlertModal = (message) => {
    this.setState({
      open: true,
      modalMessage: message
    });
  };

  /**
   * @description This function hides the alert modal.
   */
  onCloseModal = () => {
    this.setState({ open: false });
  };

  render() {
    const { open } = this.state;
    return (
      <Modal open={open} onClose={this.onCloseModal} center>
        <div className="rqst-accs-popup" >
          <div className="popup-cntnt popuptext">
            <p>{this.state.modalMessage}</p>
          </div>
          <button className="btn-prmry btn-rqst-accs" onClick={this.onCloseModal}>{CONSTANT.BUTTONS.OK}</button>
        </div>
      </Modal>
    );
  }
}

export default withRouter(AlertModal);